// extracted by mini-css-extract-plugin
export default {"TabbedContainer":"cF1XgD4e","TabPanel":"xUDUbhT6"};